import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertService } from '../../alert/alert.service';
import { BaseService } from '../../base.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportPickingService extends BaseService {

  constructor(public http: HttpClient, alertService: AlertService) {
    super(alertService, http);
  }

  downloadReportExcel(params: any) {
    const queryParams = new HttpParams({ fromObject: params });

    this.http
      .get<any>(`${this.api}/reports/picking`, {
        params: queryParams,
        observe: 'response',
        responseType: 'arraybuffer' as 'json'
      })
      .pipe(
        map((res: HttpResponse<any>) => {
          return {
            filename: 'picking.xlsx',
            data: new Blob([res.body], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
          };
        })
      )
      .subscribe((res) => {
        const link = window.URL.createObjectURL(res.data);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = link;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(link);
        a.remove();
      });
  }
}
